import {
  type EmployeeQueries,
  defEmployeeQueries,
} from '@kizen/query/employee';
import AxiosService from '__services/AxiosService';

const queries: EmployeeQueries = defEmployeeQueries(AxiosService);

export const employeeHistoryQuery: EmployeeQueries['employeeHistoryQuery'] =
  queries.employeeHistoryQuery;
